module.exports = __webpack_public_path__ + "images/87c75862203099a300570087ed481af9-ab-mapClusterGrey.png";